<template>
    <form-section
        id="contract-information"
        method="patch"
        :url="url"
        :read_only="read_only"
    >
        <purchase-price
            :read_only="read_only"
        />

        <contract-date
            :read_only="read_only"
        />

        <inspection
            :inspection="property.inspection"
            :read_only="read_only"
        />

        <attorney-review
            :attorney="property.attorney"
            :read_only="read_only"
        />

        <mortgage-contingency
            :mortgage="property.mortgage"
            :read_only="read_only"
        />

        <closing-date
            :read_only="read_only"
        />

        <who-pays-title
            :deal="property.deal"
            :read_only="read_only"
        />
    </form-section>
</template>

<script>
import FormSection from '../../components/form-section.vue';
import PurchasePrice from '../../deal/contract-information/purchase-price.vue';
import ContractDate from '../../deal/contract-information/contract-date.vue';
import Inspection from '../../deal/contract-information/inspection.vue';
import AttorneyReview from '../../deal/contract-information/attorney-review.vue';
import MortgageContingency from '../../deal/contract-information/mortgage-contingency.vue';
import ClosingDate from '../../deal/contract-information/closing-date.vue';
import WhoPaysTitle from '../../deal/contract-information/who-pays-title.vue';

export default {
    components: {
        FormSection,
        PurchasePrice,
        ContractDate,
        Inspection,
        AttorneyReview,
        MortgageContingency,
        ClosingDate,
        WhoPaysTitle,
    },

    props: {
        url: {},
        closed: { default: true },
        property: { default: () => ({}) },
        read_only: { default: false },
    },
}
</script>
